import { useEffect } from "react";

const APP_NAME = "The Gospel and Church Health Framework";

const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | GCCHF` : APP_NAME;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute("content", description);
    }

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", title ? `${title} | GCCHF` : APP_NAME);

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc && description) ogDesc.setAttribute("content", description);
  }, [title, description]);
};

export default usePageMeta;
